(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  // Minimal Slick: mobile only
  (function() {
    function init() {
      if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;
      var $ = jQuery;
      var $grids = $('.aer-blog-posts .js-blog-posts');
      $grids.each(function() {
        var $el = $(this);
        if ($el.hasClass('slick-initialized')) return;
        $el.slick({
          mobileFirst: true,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          infinite: false,
          adaptiveHeight: true,
          responsive: [
            { breakpoint: 769, settings: 'unslick' }
          ]
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-init after resize when returning to mobile from desktop
    window.addEventListener('resize', function() {
      if (window.innerWidth < 769) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cruiser-tech-features"] && !Shopify.designMode) return;
  try {
    
  function initializeTechSwiper() {
    if (typeof window.initCruiserTechnologySwipers !== 'function') {
      setTimeout(initializeTechSwiper, 100);
      return;
    }

    window.initCruiserTechnologySwipers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTechSwiper);
  } else {
    initializeTechSwiper();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcementbar"] && !Shopify.designMode) return;
  try {
    
  window.discountCode = function (e) {
    var button = e.target.closest('button');
    var copyText = button.previousElementSibling;
    var discountTooltip = button.closest('.discount-tooltip');

    // Prefer modern clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(copyText.innerText)
        .then(() => {
          var tooltip = button.querySelector('#copyTooltip');
          tooltip.innerHTML = 'Copied: ' + copyText.innerText;
          discountTooltip.classList.add('copied');
        })
        .catch((err) => {
          console.error('Clipboard API failed: ', err);
        });
    } else {
      // Fallback for older browsers
      var textArea = document.createElement('textarea');
      textArea.value = copyText.innerText;

      // Prevent Safari scroll bug
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '-9999px';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        var tooltip = button.querySelector('#copyTooltip');
        tooltip.innerHTML = 'Copied: ' + copyText.innerText;
        discountTooltip.classList.add('copied');
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    }
  };

  // Add mouse hover functionality to pause/resume marquee
  document.addEventListener('DOMContentLoaded', function () {
    const announcementWrappers = document.querySelectorAll('.alterego-announcement-wrapper');

    announcementWrappers.forEach((wrapper) => {
      const textWraps = wrapper.querySelectorAll('.alterego-announcement-text-wrap');

      wrapper.addEventListener('mouseenter', function () {
        textWraps.forEach((wrap) => {
          wrap.classList.add('paused');
        });
      });

      wrapper.addEventListener('mouseleave', function () {
        textWraps.forEach((wrap) => {
          wrap.classList.remove('paused');
        });
      });
    });
  });

  // sign-up-button
  document.addEventListener('DOMContentLoaded', function () {
    const signUpButton = document.querySelectorAll('.sign-up-button a[href="#sign-up"]');
    signUpButton.forEach((button) => {
      button.addEventListener('click', function () {
        const needsClick = document.querySelector('.needsclick[role="button"]');
        if (needsClick) {
          needsClick.click();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class MobileMenu {
    constructor() {
      this.mobileMenu = document.querySelector('[data-mobile-menu]');
      this.menuTrigger = document.querySelector('[data-mobile-menu-trigger]');
      this.closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
      this.submenuTriggers = document.querySelectorAll('[data-submenu-trigger]');
      this.submenuBackButtons = document.querySelectorAll('[data-submenu-back]');

      this.init();
    }

    init() {
      if (!this.mobileMenu) return;

      // Toggle mobile menu
      this.menuTrigger?.addEventListener('click', () => {
        this.mobileMenu.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });

      this.closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          this.closeMenu();
        });
      });

      // Handle submenus
      this.submenuTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const submenuId = trigger.getAttribute('data-submenu-trigger');
          const submenu = document.querySelector(`[data-submenu="${submenuId}"]`);

          if (submenu) {
            submenu.classList.add('is-active');
            this.mobileMenu.classList.add('has-submenu-open');
          }
        });
      });

      this.submenuBackButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const submenu = button.closest('.mobile-submenu');
          if (submenu) {
            submenu.classList.remove('is-active');
            const stillOpen = this.mobileMenu.querySelector('.mobile-submenu.is-active');
            this.mobileMenu.classList.toggle('has-submenu-open', Boolean(stillOpen));
          }
        });
      });

      // Close menu on overlay click
      document.addEventListener('click', (e) => {
        if (e.target === this.mobileMenu) {
          this.closeMenu();
        }
      });
    }

    closeMenu() {
      this.mobileMenu.classList.remove('is-active');
      this.mobileMenu.classList.remove('has-submenu-open');
      document.body.style.overflow = '';

      // Reset all submenus
      const activeSubmenus = this.mobileMenu.querySelectorAll('.mobile-submenu.is-active');
      activeSubmenus.forEach((submenu) => {
        submenu.classList.remove('is-active');
      });
    }
  }

  // Initialize mobile menu
  window.addEventListener('DOMContentLoaded', () => {
    new MobileMenu();
  });
  // Function to update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartCounts = document.querySelectorAll('[data-cart-count]');
        cartCounts.forEach((count) => {
          count.textContent = cart.item_count;
          count.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch((error) => console.error('Error updating cart count:', error));
  }

  // Hide wishlist badge when 0, show when 1+
  function updateWishlistBadgeVisibility(el) {
    const count = parseInt(el.getAttribute('data-total') || el.textContent || '0', 10);
    el.style.display = count > 0 ? '' : 'none';
  }

  function initWishlistBadgeVisibility() {
    document.querySelectorAll('.wishlist-total-count[data-wishlist-count-badge]').forEach((el) => {
      updateWishlistBadgeVisibility(el);
      const obs = new MutationObserver(() => updateWishlistBadgeVisibility(el));
      obs.observe(el, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-total'],
      });
    });
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('cart:refresh', updateCartCount);

  // Also update when items are added/removed via ajax
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      const responseUrl = (response && response.url) || '';
      if (
        responseUrl.includes('/cart/add.js') ||
        responseUrl.includes('/cart/update.js') ||
        responseUrl.includes('/cart/change.js') ||
        responseUrl.includes('/cart/clear.js')
      ) {
        updateCartCount();
      }
      return response;
    });
  };

  // Initial cart count update and wishlist badge visibility
  document.addEventListener('DOMContentLoaded', () => {
    updateCartCount();
    initWishlistBadgeVisibility();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-logo-marquee-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Pause on tap/hover — disabled for now
    var RESUME_DELAY_MS = 3000;

    function initMarquee(section) {
      var viewport = section.querySelector('.custom-logo-marquee__viewport');
      var track = section.querySelector('.custom-logo-marquee__track');
      if (!viewport || !track) return;

      var resumeTimeoutId = null;

      function pause() {
        track.classList.add('is-touch-paused');
        if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
      }

      function resume() {
        track.classList.remove('is-touch-paused');
        resumeTimeoutId = null;
      }

      function onTap() {
        if (typeof window.matchMedia === 'function' && !window.matchMedia('(max-width: 749px)').matches) return;
        if (track.classList.contains('is-touch-paused') && resumeTimeoutId !== null) {
          clearTimeout(resumeTimeoutId);
          resume();
          return;
        }
        pause();
        resumeTimeoutId = setTimeout(resume, RESUME_DELAY_MS);
      }

      viewport.addEventListener('click', onTap);
    }

    document.querySelectorAll('[data-custom-logo-marquee]').forEach(initMarquee);
    */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-your-fit"] && !Shopify.designMode) return;
  try {
    
  function initializeFitSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initializeFitSwiper, 100);
      return;
    }

    var fitThumbs = new Swiper('.fit-thumbs-slider', {
    autoplay: false,
    speed: 500,
    slidesPerView: 4,
    freeMode: false,
    loop: true,
    watchSlidesProgress: true,
    spaceBetween: 20,
    centeredSlides: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      475: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      550: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      },
      1280: {
        slidesPerView: 6,
      },
      1440: {
        slidesPerView: 6,
      },
    },
  });

  var fitSlider = new Swiper('.fit-slider', {
    autoplay: false,
    effect: 'fade',
    speed: 500,
    slidesPerView: 1,
    freeMode: false,
    loop: true,
    watchSlidesProgress: true,
    spaceBetween: 30,
    centeredSlides: false,
    thumbs: {
      swiper: fitThumbs,
    },
    navigation: {
      nextEl: '.fit-next-button',
      prevEl: '.fit-prev-button',
    },
  });

    fitThumbs.slides.forEach((slide, index) => {
      slide.addEventListener('mouseover', () => {
        fitSlider.slideToLoop(index);
      });
    });
  }

  initializeFitSwiper();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-alt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFooterAltAccordions() {
      const footer = document.querySelector('.footer-alt');
      if (!footer) return;

      footer.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-accordion-trigger]');
        if (!trigger) return;

        const accordion = trigger.closest('[data-accordion]');
        const panel = accordion?.querySelector('[data-accordion-panel]');
        if (!accordion || !panel) return;

        const isOpen = accordion.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen);
      });
    }

    function initNewsletterJoin() {
      const wrap = document.querySelector('.footer-alt__newsletter-form-wrap');
      if (!wrap) return;

      const joinBtn = wrap.querySelector('[data-newsletter-join]');
      if (!joinBtn) return;

      joinBtn.addEventListener('click', function () {
        wrap.classList.add('is-expanded');
        joinBtn.hidden = true;

        const firstInput = wrap.querySelector(
          'input[type="email"], .klaviyo-emailinput input, input:not([type="hidden"]):not([type="submit"])'
        );
        firstInput?.focus();
      });
    }

    function renameFooterKlaviyoSubmit() {
      const wrap = document.querySelector(
        '.footer-alt__newsletter-form-wrap[data-klaviyo-submit-label]'
      );
      if (!wrap) return;

      const label = wrap.getAttribute('data-klaviyo-submit-label');
      if (!label) return;

      const applyLabel = () => {
        const submitBtn = wrap.querySelector('button.klaviyo-form-button');
        if (!submitBtn || submitBtn.textContent.trim() === label) return;

        submitBtn.textContent = label;
      };

      applyLabel();

      const observer = new MutationObserver(applyLabel);
      observer.observe(wrap, { childList: true, subtree: true, characterData: true });
    }

    function init() {
      initFooterAltAccordions();
      initNewsletterJoin();
      renameFooterKlaviyoSubmit();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hat-fit-guide"] && !Shopify.designMode) return;
  try {
    
  function initializeHatFitSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initializeHatFitSwiper, 100);
      return;
    }

    var hatFitSliderThumbs = new Swiper('.custom-page-thumb-slider', {
      autoplay: false,
      freeMode: true,
      loop: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      spaceBetween: 10,
      centeredSlides: false,
      multipleActiveThumbs: false,
      breakpoints: {
        0: {
          slidesPerView: 1.5,
        },
        375: {
          slidesPerView: 2,
        },
        550: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    });

    var hatFitSlider = new Swiper('.custom-page-slider', {
      autoplay: false,
      speed: 500,
      slidesPerView: 2,
      freeMode: false,
      loop: true,
      watchSlidesProgress: true,
      spaceBetween: 30,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
      thumbs: {
        swiper: hatFitSliderThumbs,
      },
    });

    const hatFitSliderWrapper = hatFitSlider.wrapperEl;

    [].forEach.call(hatFitSlider.slides, function (slide) {
      slide.style.height = '';
    });

    setTimeout(() => {
      [].forEach.call(hatFitSlider.slides, function (slide) {
        slide.style.height = hatFitSliderWrapper.clientHeight + 'px';
      });
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHatFitSwiper);
  } else {
    initializeHatFitSwiper();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroBannerVideos = () => {
      document.querySelectorAll('[data-hero-banner-video]').forEach((wrap) => {
        const video = wrap.querySelector('.hero-banner__video');
        const poster = wrap.querySelector('.hero-banner__video-poster');
        if (!video || wrap.dataset.heroVideoInit === '1') return;

        wrap.dataset.heroVideoInit = '1';
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');

        const startPlayback = () => {
          wrap.classList.add('hero-banner__video-wrap--playing');
          if (poster) poster.setAttribute('aria-hidden', 'true');
          video.play().catch(() => {});
        };

        let started = false;
        let fallbackId = null;
        const clearFallback = () => {
          if (fallbackId) {
            clearTimeout(fallbackId);
            fallbackId = null;
          }
        };
        const tryStart = () => {
          clearFallback();
          if (started) return;
          started = true;
          startPlayback();
        };

        const onCanPlayThrough = () => {
          video.removeEventListener('canplaythrough', onCanPlayThrough);
          video.removeEventListener('loadeddata', onLoadedData);
          video.removeEventListener('loadedmetadata', onLoadedMetadata);
          tryStart();
        };

        const onLoadedData = () => {
          if (video.readyState >= 4) {
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            video.removeEventListener('loadeddata', onLoadedData);
            video.removeEventListener('loadedmetadata', onLoadedMetadata);
            tryStart();
          }
        };

        const onLoadedMetadata = () => {
          if (video.readyState >= 4) {
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            video.removeEventListener('loadeddata', onLoadedData);
            video.removeEventListener('loadedmetadata', onLoadedMetadata);
            tryStart();
          }
        };

        const attachListeners = () => {
          if (video.readyState >= 4) {
            tryStart();
            return;
          }
          video.addEventListener('canplaythrough', onCanPlayThrough);
          video.addEventListener('loadeddata', onLoadedData);
          video.addEventListener('loadedmetadata', onLoadedMetadata);
          fallbackId = setTimeout(() => {
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            video.removeEventListener('loadeddata', onLoadedData);
            video.removeEventListener('loadedmetadata', onLoadedMetadata);
            video.load();
            tryStart();
          }, 4000);
        };

        const observer = new IntersectionObserver(
          (entries) => {
            const e = entries[0];
            if (!e?.isIntersecting) return;
            observer.disconnect();
            video.load();
            attachListeners();
          },
          { rootMargin: '0px', threshold: 0.1 },
        );
        observer.observe(wrap);
      });
    };

    const initHeroBannerScrollButtons = () => {
      document.querySelectorAll('[data-hero-banner-scroll-target]').forEach((button) => {
        if (!(button instanceof HTMLElement) || button.dataset.heroBannerScrollInit === '1') return;

        button.dataset.heroBannerScrollInit = '1';

        button.addEventListener('click', (event) => {
          const className = button.dataset.heroBannerScrollTarget?.trim().replace(/^\./, '');
          if (!className) return;

          const target = document.getElementsByClassName(className)[0];
          if (!(target instanceof HTMLElement)) return;

          event.preventDefault();

          const offset = 100;
          const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;

          window.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth',
          });
        });
      });
    };

    const initHeroBanner = () => {
      initHeroBannerVideos();
      initHeroBannerScrollButtons();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroBanner);
    } else {
      initHeroBanner();
    }

    document.addEventListener('shopify:section:load', initHeroBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RESUME_DELAY_MS = 3000;

    function initMarquee(section) {
      var viewport = section.querySelector('.marquee-strip__viewport');
      var track = section.querySelector('.marquee-strip__track');
      if (!viewport || !track) return;

      var resumeTimeoutId = null;

      function pause() {
        track.classList.add('is-touch-paused');
        if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
      }

      function resume() {
        track.classList.remove('is-touch-paused');
        resumeTimeoutId = null;
      }

      function onTap() {
        if (typeof window.matchMedia === 'function' && !window.matchMedia('(max-width: 749px)').matches) return;
        if (track.classList.contains('is-touch-paused') && resumeTimeoutId !== null) {
          if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
          resume();
          return;
        }
        pause();
        resumeTimeoutId = setTimeout(resume, RESUME_DELAY_MS);
      }

      viewport.addEventListener('click', onTap);
    }
    document.querySelectorAll('[data-marquee-strip]').forEach(initMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-showcase-cms-pages"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const colorwayDataCache = new Map();

    function initSection(section) {
      if (!section || !section.hasAttribute('data-product-collection-showcase-section')) return;

      const collectionHandleValue = section.dataset.collectionHandle || '';
      if (!collectionHandleValue) return;

      const productLimit = parseInt(section.dataset.productLimit, 10) || 4;
      const showBadge = section.dataset.showBadge !== 'false';

      const mainSwiperElement = section.querySelector('[data-product-collection-swiper]');
      const productWrapperElement = section.querySelector('[data-product-wrapper]');
      const paginationEl = section.querySelector('.product-collection-showcase__pagination-wrap .swiper-pagination');
      const progressBar = section.querySelector('[data-progress-bar]');
      const progressBarFill = progressBar
        ? progressBar.querySelector('.product-collection-showcase__progress-bar')
        : null;
      let mainSwiperInstance = null;
      let resizeDebounceTimer = null;

      const flattenGraphQLConnections = (graphQLObject) => {
        if (!(graphQLObject && typeof graphQLObject === 'object') || Array.isArray(graphQLObject)) return graphQLObject;
        if ('edges' in graphQLObject && Array.isArray(graphQLObject.edges)) {
          return graphQLObject.edges.map((edgeItem) => flattenGraphQLConnections(edgeItem.node));
        }
        for (const propertyName in graphQLObject)
          graphQLObject[propertyName] = flattenGraphQLConnections(graphQLObject[propertyName]);
        return graphQLObject;
      };

      /**
       * Storefront GraphQL returns catalog/retail prices and ignores logged-in
       * wholesale/B2B customer context. Overlay session-aware prices from the
       * Ajax Product API (same source Liquid uses on PDPs / YMAL).
       */
      const centsToAmountString = (cents) => (Number(cents || 0) / 100).toFixed(2);

      const applyCustomerAwarePricing = (graphqlProduct, productJson) => {
        if (!graphqlProduct || !productJson) return graphqlProduct;

        const currencyCode =
          graphqlProduct.priceRange?.minVariantPrice?.currencyCode ||
          (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) ||
          'USD';

        const priceMinCents =
          productJson.price_min != null ? productJson.price_min : productJson.price;
        const priceMinAmount = centsToAmountString(priceMinCents);

        graphqlProduct.priceRange = {
          minVariantPrice: {
            amount: priceMinAmount,
            currencyCode,
          },
        };

        const compareAtMinCents =
          productJson.compare_at_price_min != null
            ? productJson.compare_at_price_min
            : productJson.compare_at_price;

        if (compareAtMinCents != null && Number(compareAtMinCents) > Number(priceMinCents)) {
          graphqlProduct.compareAtPriceRange = {
            minVariantPrice: {
              amount: centsToAmountString(compareAtMinCents),
              currencyCode,
            },
          };
        } else {
          graphqlProduct.compareAtPriceRange = {
            minVariantPrice: {
              amount: '0',
              currencyCode,
            },
          };
        }

        if (Array.isArray(graphqlProduct.variants) && Array.isArray(productJson.variants)) {
          const priceByVariantId = new Map();
          productJson.variants.forEach((variantJson) => {
            priceByVariantId.set(String(variantJson.id), variantJson.price);
          });

          graphqlProduct.variants.forEach((variant) => {
            const variantId =
              typeof variant.id === 'string' && variant.id.includes('/')
                ? variant.id.split('/').pop()
                : String(variant.id);
            if (!priceByVariantId.has(variantId)) return;
            variant.price = {
              amount: centsToAmountString(priceByVariantId.get(variantId)),
              currencyCode,
            };
          });
        }

        return graphqlProduct;
      };

      const hydrateProductsWithCustomerPrices = async (products) => {
        if (!products?.length) return products;

        return Promise.all(
          products.map(async (product) => {
            if (!product?.handle) return product;
            try {
              const response = await fetch(`/products/${product.handle}.js`);
              if (!response.ok) return product;
              const productJson = await response.json();
              return applyCustomerAwarePricing(product, productJson);
            } catch (error) {
              return product;
            }
          }),
        );
      };

      const fetchCollectionProducts = async () => {
        try {
          const countryCode = section.dataset.countryCode || null;
          const apiResponse = await fetch('/api/2024-07/graphql.json', {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'x-shopify-storefront-access-token': '9f39520505c5a1a7f0bab22fb8a87abf',
            },
            body: JSON.stringify({
              query: countryCode
                ? `
              query getCollectionProducts($handle: String!, $first: Int!, $country: CountryCode!) @inContext(country: $country) {
                collection(handle: $handle) {
                  products(first: $first) {
                    edges {
                      node {
                        id
                        handle
                        title
                        tags
                        options { name values }
                        priceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        compareAtPriceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        images(first: 10) {
                          edges {
                            node {
                              url(transform: {maxWidth: 600, maxHeight: 800})
                              width height altText
                            }
                          }
                        }
                        variants(first: 250) {
                          edges {
                            node {
                              id title availableForSale
                              price { amount currencyCode }
                              image {
                                url(transform: {maxWidth: 100, maxHeight: 100})
                                width height
                              }
                              selectedOptions { name value }
                              metafield(namespace: "custom", key: "swatch_image") { value }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            `
                : `
              query getCollectionProducts($handle: String!, $first: Int!) {
                collection(handle: $handle) {
                  products(first: $first) {
                    edges {
                      node {
                        id
                        handle
                        title
                        tags
                        options { name values }
                        priceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        compareAtPriceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        images(first: 10) {
                          edges {
                            node {
                              url(transform: {maxWidth: 600, maxHeight: 800})
                              width height altText
                            }
                          }
                        }
                        variants(first: 250) {
                          edges {
                            node {
                              id title availableForSale
                              price { amount currencyCode }
                              image {
                                url(transform: {maxWidth: 100, maxHeight: 100})
                                width height
                              }
                              selectedOptions { name value }
                              metafield(namespace: "custom", key: "swatch_image") { value }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            `,
              variables: countryCode
                ? { handle: collectionHandleValue, first: productLimit, country: countryCode }
                : { handle: collectionHandleValue, first: productLimit },
            }),
          });

          const responseData = await apiResponse.json();
          if (!responseData?.data?.collection?.products) {
            return [];
          }

          const flattenedProducts = flattenGraphQLConnections(responseData.data.collection.products);
          return hydrateProductsWithCustomerPrices(flattenedProducts.slice(0, productLimit));
        } catch (error) {
          return [];
        }
      };

      const validateImageUrl = (imageUrl) => {
        if (!imageUrl) return Promise.resolve(false);
        const timeoutMs = 4000;
        return (async () => {
          try {
            const c = new AbortController();
            const t = setTimeout(() => c.abort(), timeoutMs);
            const res = await fetch(imageUrl, { method: 'GET', signal: c.signal, credentials: 'omit' });
            clearTimeout(t);
            if (res.status === 404) return false;
            if (!res.ok) return false;
            const ct = (res.headers.get('Content-Type') || '').toLowerCase();
            if (ct && !ct.startsWith('image/')) return false;
            return true;
          } catch (e) {
            try {
              return await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = imageUrl;
                setTimeout(() => resolve(false), timeoutMs);
              });
            } catch (err) {
              return false;
            }
          }
        })();
      };

      const extractSwatchImageFromVariant = (variantData) => {
        if (!variantData) return null;

        let swatchImageValue = null;

        if (variantData.metafield) {
          if (variantData.metafield.value !== null && variantData.metafield.value !== undefined) {
            swatchImageValue = variantData.metafield.value;
          } else if (typeof variantData.metafield === 'string') {
            swatchImageValue = variantData.metafield;
          }
        } else if (variantData.metafields && variantData.metafields.swatch_image) {
          swatchImageValue = variantData.metafields.swatch_image;
        }

        if (swatchImageValue !== null && swatchImageValue !== undefined) {
          const trimmedSwatchValue = String(swatchImageValue).trim();
          if (
            trimmedSwatchValue &&
            trimmedSwatchValue.length > 0 &&
            trimmedSwatchValue !== 'null' &&
            trimmedSwatchValue !== 'undefined' &&
            trimmedSwatchValue !== '' &&
            (trimmedSwatchValue.startsWith('http://') || trimmedSwatchValue.startsWith('https://'))
          ) {
            return trimmedSwatchValue;
          }
        }
        return null;
      };

      const isStandardVariant = (variant) => {
        if (!variant) return false;
        const titleDowncase = (variant.title || '').toLowerCase();
        if (titleDowncase.includes('standard')) return true;
        const options = variant.selectedOptions || [];
        for (let i = 0; i < options.length; i++) {
          if ((options[i].value || '').toLowerCase() === 'standard') return true;
        }
        return false;
      };

      const getVariantSwatchOrder = (variants) => {
        if (!variants || !variants.length) return [];
        const standard = variants.find(isStandardVariant);
        if (standard) {
          const rest = variants.filter((v) => v !== standard);
          return [standard, ...rest];
        }
        return [...variants];
      };

      const getFirstValidSwatchUrl = async (colorwayProductItem) => {
        const variants = colorwayProductItem.variants || [];
        const ordered = getVariantSwatchOrder(variants);
        for (const variant of ordered) {
          const metafieldUrl = extractSwatchImageFromVariant(variant);
          if (metafieldUrl && (await validateImageUrl(metafieldUrl))) return metafieldUrl;
        }
        for (const variant of ordered) {
          if (variant?.image?.url && (await validateImageUrl(variant.image.url))) return variant.image.url;
        }
        return null;
      };

      const extractColorTagFromProduct = (productData) => {
        if (!productData.tags || !Array.isArray(productData.tags)) return null;

        for (const productTag of productData.tags) {
          if (productTag.includes('_') && productTag !== 'new_arrival' && productTag !== 'Endless_Summer') {
            return productTag;
          }
        }
        return null;
      };

      const fetchColorwayProductsByTag = async (colorTag) => {
        if (colorwayDataCache.has(colorTag)) {
          return colorwayDataCache.get(colorTag);
        }

        try {
          const colorwayApiResponse = await fetch('/api/2024-07/graphql.json', {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'x-shopify-storefront-access-token': '9f39520505c5a1a7f0bab22fb8a87abf',
            },
            body: JSON.stringify({
              query: `
              query getProductsByTag($query: String!) {
                colorways: products(query: $query, first: 50) {
                  edges {
                    node {
                      handle
                      title
                      images(first: 2) {
                        edges {
                          node {
                            width
                            height
                            url(transform: {maxHeight: 100, maxWidth: 100})
                          }
                        }
                      }
                      variants(first: 250) {
                        edges {
                          node {
                            title
                            availableForSale
                            image {
                              url(transform: {maxHeight: 100, maxWidth: 100})
                              width
                              height
                            }
                            selectedOptions {
                              name
                              value
                            }
                            metafield(namespace: "custom", key: "swatch_image") {
                              value
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            `,
              variables: { query: `tag:${colorTag}` },
            }),
          });

          const colorwayResponseData = await colorwayApiResponse.json();
          const flattenedColorwayProducts = flattenGraphQLConnections(colorwayResponseData?.data?.colorways || []);

          colorwayDataCache.set(colorTag, flattenedColorwayProducts);
          return flattenedColorwayProducts;
        } catch (error) {
          return [];
        }
      };

      const getProductColorOptions = async (productData) => {
        try {
          const productColorTag = extractColorTagFromProduct(productData);
          if (!productColorTag) return [];

          const colorwayProductsList = await fetchColorwayProductsByTag(productColorTag);
          if (colorwayProductsList.length === 0) return [];

          const uniqueColorOptionsMap = new Map();

          const colorwayProcessingPromises = colorwayProductsList.map(async (colorwayProductItem) => {
            let fallbackImageUrl = null;
            if (colorwayProductItem.variants?.length) {
              const v = colorwayProductItem.variants.find((x) => x.image?.url);
              fallbackImageUrl = v?.image?.url || colorwayProductItem.variants[0]?.image?.url;
            }
            if (!fallbackImageUrl && colorwayProductItem.images?.[0]?.url) {
              fallbackImageUrl = colorwayProductItem.images[0].url;
            }

            const swatchImageUrl = await getFirstValidSwatchUrl(colorwayProductItem);
            const finalImage = swatchImageUrl || fallbackImageUrl;
            const finalFallback = fallbackImageUrl || finalImage;

            return {
              name: colorwayProductItem.title,
              handle: colorwayProductItem.handle,
              image: finalImage,
              fallback: finalFallback,
              available: colorwayProductItem.variants?.some((variantItem) => variantItem.availableForSale) || false,
            };
          });

          const processedColorOptions = await Promise.all(colorwayProcessingPromises);

          processedColorOptions.forEach((colorOption) => {
            if (!uniqueColorOptionsMap.has(colorOption.handle)) {
              uniqueColorOptionsMap.set(colorOption.handle, colorOption);
            }
          });

          return Array.from(uniqueColorOptionsMap.values());
        } catch (error) {
          return [];
        }
      };

      const formatProductPrice = (priceAmount, currencyCodeValue) => {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currencyCodeValue || 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(parseFloat(priceAmount));
      };

      const renderProductCardHTML = async (productData, colorOptionsList = []) => {
        if (typeof window.renderProductShowcaseCard === 'function') {
          const productCardHTML = window.renderProductShowcaseCard(
            productData,
            colorOptionsList,
            'product-collection-showcase',
            showBadge,
            true,
          );
          return `<div class="swiper-slide">${productCardHTML}</div>`;
        }

        return '';
      };

      const initializeProductImageSwipers = () => {
        if (typeof window.initProductShowcaseCardImageSwipers === 'function') {
          window.initProductShowcaseCardImageSwipers(section);
        }
      };

      const getSlidesPerView = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 749) {
          return 1.6;
        } else if (windowWidth <= 1023) {
          return 3;
        } else {
          return 4;
        }
      };

      const initializeMainSwiper = () => {
        if (!mainSwiperElement || typeof Swiper === 'undefined') {
          if (typeof Swiper === 'undefined') {
            setTimeout(() => initializeMainSwiper(), 100);
          }
          return;
        }

        if (typeof window.initProductCollectionShowcaseMainSwiper !== 'function') {
          setTimeout(() => initializeMainSwiper(), 100);
          return;
        }

        mainSwiperInstance = window.initProductCollectionShowcaseMainSwiper({
          swiperElement: mainSwiperElement,
          progressBar,
          progressBarFill,
          paginationEl,
          existingInstance: mainSwiperInstance,
          getSlidesPerView,
          onInit: (swiper, progress) => {
            initializeProductImageSwipers();
            progress.updateProgressBar(swiper);
          },
        });
      };

      const loadAndRenderProducts = async () => {
        try {
          const fetchedProducts = await fetchCollectionProducts();
          if (fetchedProducts.length === 0) {
            const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
            skeletonElements.forEach((skeletonElement) => skeletonElement.remove());
            section.classList.remove('product-collection-showcase--many-products');
            return;
          }

          const colorTagToProductsMap = new Map();
          fetchedProducts.forEach((productItem) => {
            const productColorTag = extractColorTagFromProduct(productItem);
            if (productColorTag && !colorTagToProductsMap.has(productColorTag)) {
              colorTagToProductsMap.set(productColorTag, []);
            }
            if (productColorTag) {
              colorTagToProductsMap.get(productColorTag).push(productItem);
            }
          });

          const colorwayFetchPromises = Array.from(colorTagToProductsMap.keys()).map((colorTag) =>
            fetchColorwayProductsByTag(colorTag),
          );
          await Promise.all(colorwayFetchPromises);

          const colorOptionsFetchPromises = fetchedProducts.map((productItem) => getProductColorOptions(productItem));
          const allProductColorOptions = await Promise.all(colorOptionsFetchPromises);

          let functionCheckRetries = 0;
          while (typeof window.renderProductShowcaseCard !== 'function' && functionCheckRetries < 10) {
            await new Promise((resolve) => setTimeout(resolve, 100));
            functionCheckRetries++;
          }

          if (typeof window.renderProductShowcaseCard !== 'function') {
            const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
            skeletonElements.forEach((skeletonElement) => skeletonElement.remove());
            section.classList.remove('product-collection-showcase--many-products');
            return;
          }

          const productCardRenderPromises = fetchedProducts.map((productItem, productIndex) =>
            renderProductCardHTML(productItem, allProductColorOptions[productIndex]),
          );
          const renderedCardHTMLs = await Promise.all(productCardRenderPromises);

          const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
          skeletonElements.forEach((skeletonElement) => skeletonElement.remove());

          productWrapperElement.innerHTML = renderedCardHTMLs.join('');

          /* Toggle pagination visibility on desktop: hide when 4 or fewer products */
          section.classList.toggle('product-collection-showcase--many-products', fetchedProducts.length > 4);

          setTimeout(() => {
            if (typeof window.initCardSkeletons === 'function') {
              window.initCardSkeletons();
            }
          }, 50);

          initializeMainSwiper();

          setTimeout(() => {
            if (mainSwiperInstance) {
              mainSwiperInstance.update();
            }
            initializeProductImageSwipers();
          }, 100);

          const productDataLoadPromises = fetchedProducts.map((productItem) =>
            loadProductAdditionalData(productItem.handle),
          );
          await Promise.all(productDataLoadPromises);

          setTimeout(() => {
            fetchedProducts.forEach((productItem) => {
              const productCardElement = section.querySelector(
                '.product-collection-showcase__card[data-product-handle="' + productItem.handle + '"]',
              );
              if (productCardElement && productCardElement.getAttribute('data-loading') === 'true') {
                const cardImageWrapper = productCardElement.querySelector(
                  '.product-collection-showcase__card-image-wrapper',
                );
                const firstProductImage = cardImageWrapper?.querySelector('img');
                if (firstProductImage && firstProductImage.complete && firstProductImage.naturalHeight > 0) {
                  productCardElement.setAttribute('data-loading', 'false');
                }
              }
            });
          }, 500);
        } catch (error) {
          const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
          skeletonElements.forEach((skeletonElement) => skeletonElement.remove());
          section.classList.remove('product-collection-showcase--many-products');
        }
      };

      const loadProductAdditionalData = async (productHandleValue) => {
        try {
          const productDataUrl = `/products/${productHandleValue}?view=review`;
          const productDataResponse = await fetch(productDataUrl);
          const productDataHTML = await productDataResponse.text();
          const temporaryDiv = document.createElement('div');
          temporaryDiv.innerHTML = productDataHTML;

          const customDisplayTextElement = temporaryDiv.querySelector('.custom_display_text');
          const customTitleContainer = section.querySelector(
            `.product-collection-showcase__card[data-product-handle="${productHandleValue}"] .product-collection-showcase__card-custom-title`,
          );

          if (customDisplayTextElement && customTitleContainer) {
            const clonedTextElement = customDisplayTextElement.cloneNode(true);
            if (clonedTextElement.textContent) {
              if (typeof theme !== 'undefined' && theme.utils && theme.utils.toProperCase) {
                clonedTextElement.textContent = theme.utils.toProperCase(clonedTextElement.textContent);
              }
            }
            customTitleContainer.innerHTML = clonedTextElement.outerHTML;
          }

          const reviewBadgeElement = temporaryDiv.querySelector('.jdgm-preview-badge');
          const reviewContainerElement = section.querySelector(
            `.product-collection-showcase__card[data-product-handle="${productHandleValue}"] .product-collection-showcase__card-review`,
          );

          if (reviewBadgeElement && reviewContainerElement) {
            const previousBadgeElement = reviewBadgeElement.querySelector('.jdgm-prev-badge');
            const totalReviewCount = previousBadgeElement
              ? parseInt(previousBadgeElement.getAttribute('data-number-of-reviews') || '0', 10)
              : 0;

            if (totalReviewCount > 0) {
              reviewContainerElement.innerHTML = reviewBadgeElement.outerHTML;

              const reviewBadgeTextElement = reviewContainerElement.querySelector('.jdgm-prev-badge__text');
              if (reviewBadgeTextElement) {
                const reviewText = reviewBadgeTextElement.textContent.trim();
                const reviewCountMatch = reviewText.match(/(\d+)\s+review(s)?/i);
                if (reviewCountMatch) {
                  const reviewNumber = reviewCountMatch[1];
                  reviewBadgeTextElement.textContent = `(${reviewNumber})`;
                }
              }

              if (typeof window.jdgm !== 'undefined' && window.jdgm.loadWidgets) {
                window.jdgm.loadWidgets();
              }
            } else {
              const reviewWrapperElement = reviewContainerElement?.closest(
                '.product-collection-showcase__card-review-wrapper',
              );
              if (reviewWrapperElement) {
                reviewWrapperElement.style.display = 'none';
              }
            }
          }
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        } catch (error) {}
      };

      const handleProductCardClick = (clickEvent) => {
        const addToCartButton = clickEvent.target.closest('.product-collection-showcase__card-add-to-cart');
        const wishlistButton = clickEvent.target.closest(
          '.product-collection-showcase__card-wishlist',
        );
        const imageArrow = clickEvent.target.closest('.product-collection-showcase__card-image-arrow');
        const colorSwatch = clickEvent.target.closest('.product-collection-showcase__card-color-swatch');
        const productCard = clickEvent.target.closest('.product-collection-showcase__card');

        if (addToCartButton || wishlistButton || imageArrow || colorSwatch) {
          return;
        }

        if (productCard) {
          const productHandle = productCard.getAttribute('data-product-handle');
          if (productHandle) {
            window.location.href = `/products/${productHandle}`;
          }
        }
      };

      section.addEventListener('click', (clickEvent) => {
        const addToCartButton = clickEvent.target.closest('.product-collection-showcase__card-add-to-cart');
        if (!addToCartButton || addToCartButton.disabled) return;

        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        clickEvent.stopImmediatePropagation();

        const productHandleValue = addToCartButton.dataset.productHandle;
        const productIdValue = addToCartButton.getAttribute('data-product-id');
        const prefetched =
          typeof window.parseQuickAddProductFromButton === 'function'
            ? window.parseQuickAddProductFromButton(addToCartButton)
            : null;

        if (!productHandleValue) return;

        if (typeof window.openQuickAddModalProductCards === 'function') {
          window.openQuickAddModalProductCards(productHandleValue, productIdValue, prefetched, addToCartButton);
        } else {
          window.location.href = '/products/' + productHandleValue;
        }
      });

      section.addEventListener('click', handleProductCardClick);

      let sizeGuideModalCloseHandlers = {
        overlayClick: null,
        escapeKey: null,
      };

      const closeSizeGuideModal = () => {
        const toolTipElement = document.getElementById('ProductCollectionSizeGuide-' + section.dataset.sectionId);

        if (!toolTipElement) {
          return;
        }

        toolTipElement.removeAttribute('data-tool-tip-open');

        if (window.theme && window.theme.a11y && window.theme.a11y.unlockPageScroll) {
          window.theme.a11y.unlockPageScroll();
        }

        if (sizeGuideModalCloseHandlers.overlayClick) {
          document.removeEventListener('click', sizeGuideModalCloseHandlers.overlayClick);
          sizeGuideModalCloseHandlers.overlayClick = null;
        }

        if (sizeGuideModalCloseHandlers.escapeKey) {
          document.removeEventListener('keydown', sizeGuideModalCloseHandlers.escapeKey);
          sizeGuideModalCloseHandlers.escapeKey = null;
        }
      };

      const showSizeGuideModal = (modalType) => {
        if (window.theme && window.theme.SizeGuide) {
          window.theme.SizeGuide.open(modalType);
        }

        if (window.theme && window.theme.a11y && window.theme.a11y.lockPageScroll) {
          window.theme.a11y.lockPageScroll();
        }

        if (window.theme && window.theme.a11y && window.theme.a11y.lockPageScroll) {
          window.theme.a11y.lockPageScroll();
        }

        const toolTipContent = toolTipElement.querySelector('.tool-tip__content');
        const toolTipInner = toolTipElement.querySelector('.tool-tip__inner');
        const closeButton = toolTipElement.querySelector('.tool-tip__close');

        if (toolTipContent) {
          const toolTipTrigger = toolTipContent.querySelector('tool-tip-trigger');
          if (toolTipTrigger) {
            const triggerContent = toolTipTrigger.querySelector('.tool-tip-trigger__content');
            if (triggerContent) {
              const modalContent = triggerContent.querySelector('.size-guide-modal');
              if (modalContent) {
                const clonedModal = modalContent.cloneNode(true);

                const overlay = clonedModal.querySelector('.size-guide-overlay');
                const container = clonedModal.querySelector('.size-guide-container');

                if (overlay) {
                  overlay.removeAttribute('x-show');
                  overlay.removeAttribute('@click');
                  overlay.removeAttribute('x-transition:enter');
                  overlay.removeAttribute('x-transition:enter-start');
                  overlay.removeAttribute('x-transition:enter-end');
                  overlay.removeAttribute('x-transition:leave');
                  overlay.removeAttribute('x-transition:leave-start');
                  overlay.removeAttribute('x-transition:leave-end');
                }

                if (container) {
                  container.removeAttribute('x-show');
                  container.removeAttribute('x-transition:enter');
                  container.removeAttribute('x-transition:enter-start');
                  container.removeAttribute('x-transition:enter-end');
                  container.removeAttribute('x-transition:leave');
                  container.removeAttribute('x-transition:leave-start');
                  container.removeAttribute('x-transition:leave-end');
                }

                clonedModal.removeAttribute('x-cloak');
                clonedModal.removeAttribute('x-data');
                clonedModal.removeAttribute('@show-size-guide.window');
                clonedModal.removeAttribute('@click.outside');
                clonedModal.removeAttribute('x-show');
                clonedModal.removeAttribute('x-effect');
                clonedModal.removeAttribute('x-transition:enter');
                clonedModal.removeAttribute('x-transition:enter-start');
                clonedModal.removeAttribute('x-transition:enter-end');
                clonedModal.removeAttribute('x-transition:leave');
                clonedModal.removeAttribute('x-transition:leave-start');
                clonedModal.removeAttribute('x-transition:leave-end');

                toolTipTrigger.remove();
                toolTipContent.appendChild(clonedModal);

                if (overlay) {
                  overlay.style.display = 'block';
                  overlay.style.opacity = '1';
                  overlay.addEventListener('click', (e) => {
                    e.stopPropagation();
                    closeSizeGuideModal();
                  });
                }
              }
            }
          }
        }

        if (closeButton) {
          closeButton.addEventListener('click', (e) => {
            e.stopPropagation();
            closeSizeGuideModal();
          });
        }

        sizeGuideModalCloseHandlers.overlayClick = (e) => {
          if (toolTipElement.getAttribute('data-tool-tip-open') === 'true') {
            if (toolTipInner && !toolTipInner.contains(e.target) && e.target !== closeButton) {
              closeSizeGuideModal();
            }
          }
        };

        document.addEventListener('click', sizeGuideModalCloseHandlers.overlayClick);

        sizeGuideModalCloseHandlers.escapeKey = (e) => {
          if (e.key === 'Escape' && toolTipElement.getAttribute('data-tool-tip-open') === 'true') {
            closeSizeGuideModal();
          }
        };

        document.addEventListener('keydown', sizeGuideModalCloseHandlers.escapeKey);

        toolTipElement.setAttribute('data-tool-tip-open', 'true');
      };

      const sizeGuideLink = section.querySelector('.product-collection-showcase__size-guide-link');

      if (sizeGuideLink) {
        sizeGuideLink.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const detectedType = sizeGuideLink.getAttribute('data-size-guide-type');
          showSizeGuideModal(detectedType);
        });
      }

      const initializeSwiperWithSkeleton = () => {
        if (!mainSwiperElement) {
          setTimeout(() => initializeSwiperWithSkeleton(), 50);
          return;
        }

        if (typeof Swiper === 'undefined') {
          setTimeout(() => initializeSwiperWithSkeleton(), 100);
          return;
        }

        if (typeof window.initProductCollectionShowcaseMainSwiper !== 'function') {
          setTimeout(() => initializeSwiperWithSkeleton(), 100);
          return;
        }

        if (mainSwiperInstance && productWrapperElement.children.length > 0) {
          return;
        }

        try {
          mainSwiperInstance = window.initProductCollectionShowcaseMainSwiper({
            swiperElement: mainSwiperElement,
            progressBar,
            progressBarFill,
            paginationEl,
            existingInstance: mainSwiperInstance,
            getSlidesPerView,
            skeletonMode: true,
          });

          setTimeout(() => {
            if (mainSwiperInstance) {
              mainSwiperInstance.update();
            }
          }, 50);
        } catch (error) {
          setTimeout(() => initializeSwiperWithSkeleton(), 200);
        }
      };

      const initializeSkeletonState = () => {
        if (!mainSwiperElement || !productWrapperElement) {
          setTimeout(() => initializeSkeletonState(), 50);
          return;
        }

        const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
        if (skeletonElements.length === 0) {
          return;
        }

        initializeSwiperWithSkeleton();
      };

      initializeSkeletonState();

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          if (!mainSwiperInstance) {
            initializeSkeletonState();
          }
          setTimeout(function () {
            loadAndRenderProducts();
          }, 300);
        });
      } else {
        setTimeout(function () {
          loadAndRenderProducts();
        }, 300);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-product-collection-showcase-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      const section = document.querySelector(
        '[data-product-collection-showcase-section][data-section-id="' + e.detail.sectionId + '"]',
      );
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
